import { Link, useHistory } from 'react-router-dom';
import { trackLinkClick } from '../../common/analytics';
import Button from '../../common/components/button';
import Div from '../../common/components/div';
import H1 from '../../common/components/h1';
import StackingButtons from '../../common/components/stacking.buttons';
import SubHeading from '../../common/components/sub.heading.section';
import TranslatedSpan from '../../common/components/translated.span';
import the from '../../common/objects/the';

export default function NoAccountInRecords() {
    const history = useHistory();

    const getCreateAccountButton = () => {
        return <>
            <Button
                color={'teal'}
                displayAs={'button'}
                fill={'solid'}
                onClick={() => history.push('/create-account')}
                size={'small'}
            >
                <TranslatedSpan english={'Create Account'}/>
            </Button>
        </>;
    };

    const getGoToMedicareDotGovButton = () => {
        return <>
            <Button
                color={'teal'}
                displayAs={'button'}
                fill={'outlined'}
                onClick={() => document.location.href = "http://www.medicare.gov"}
                size={'small'}
            >
                <TranslatedSpan english={'Go to Medicare.gov'}/>
            </Button>
        </>;
    };

    return (
        <Div
            isContainer={true}
            paddingySM={1} paddingyMD={2} paddingyLG={3} paddingyXL={4}>
            <Div isRow={true}>
                <Div cols={12}>
                    <H1>
                        <TranslatedSpan english={'No account in our records'}/>
                    </H1>
                </Div>
            </Div>
            <SubHeading style={{fontSize: 16, fontWeight: 380}}>
                <TranslatedSpan english={'You don\'t have an account yet.'}/>{` `}
                <Link
                    style={{color: the.color.tarheelBlue}}
                    to="/create-account"
                    onClick={trackLinkClick}
                >
                    <TranslatedSpan english={'Create one'}/>
                </Link>
                {` `}<TranslatedSpan english={'for a more personalized experience.'}/>
            </SubHeading>
            <StackingButtons
                button1={getCreateAccountButton()}
                button2={getGoToMedicareDotGovButton()}
            />
        </Div>
    );
}
